import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { Globle } from 'src/assets/globle';
import { Advertize } from './advertize.model';

@Injectable({
  providedIn: 'root'
})
export class AdvertizeService {


  constructor(private http: HttpClient, private global: Globle) {

  }


  getAll(status: number) {
    return this.http.get<Advertize[]>(this.global.APIURL + "advertising?status=" + status);
  }

  getById(id: number) {
    return this.http.get<Advertize>(this.global.APIURL + "advertising/" + id);
  }

  Create(advertising: object) {
    return this.http.post(this.global.APIURL + "advertising", advertising)
  }

  Update(advertising: any) {
    return this.http.put(this.global.APIURL + "advertising", advertising)
  }

  upload(formdata: any) {
    return this.http.post<any>(this.global.APIURL + "advertising/upload", formdata)
  }

  Delete(id: number) {
    return this.http.delete(this.global.APIURL + "advertising/" + id)
  }
}
